import { useAppDispatch } from 'hooks/reduxHooks'
import {
  type unstable_AdapterOptions as AdapterOptions,
  unstable_createAdapterProvider as createAdapterProvider,
  renderQueryString,
} from 'nuqs/adapters/custom'
import { useLocation } from 'react-router-dom'
import { replace, push } from 'lib/routing/appRouting'

/**
 * nuqs does not ship a dedicated adapter for this app's Redux-backed history
 * integration, so this bridges nuqs query updates onto app routing actions.
 */
function useAppReactRouterAdapter() {
  const location = useLocation()
  const dispatch = useAppDispatch()

  const updateUrl = (search: URLSearchParams, options: AdapterOptions) => {
    if (options.history === 'push') {
      dispatch(push({ ...location, search: renderQueryString(search) }))
    } else {
      dispatch(replace({ ...location, search: renderQueryString(search) }))
    }
  }
  return {
    searchParams: new URLSearchParams(location.search),
    updateUrl,
  }
}

export const NuqsAdapter = createAdapterProvider(useAppReactRouterAdapter)
